export default function SearchIcon3() {
  return (
    <div className=" w-8 h-8 rounded-2xl flex justify-center align items-center m-c7   ">
      <i className="fa-solid fa-magnifying-glass fa-md color222"></i>
    </div>
  );
}
